/* HigienaShop Theme JS */
(function() {
  'use strict';

  /* =============================================
     TOAST NOTIFICATION
  ============================================= */
  function showToast(msg, icon) {
    var toast = document.getElementById('toast');
    if (!toast) return;
    toast.innerHTML = (icon || '✅') + ' ' + msg;
    toast.classList.add('show');
    clearTimeout(toast._timer);
    toast._timer = setTimeout(function() { toast.classList.remove('show'); }, 3500);
  }
  window.showToast = showToast;

  /* =============================================
     ANNOUNCEMENT BAR ROTATION
     (inline script in section handles it, but fallback here)
  ============================================= */

  /* =============================================
     CART DRAWER
  ============================================= */
  var cartToggle = document.getElementById('cart-toggle');
  var cartDrawer = document.getElementById('cart-drawer');
  var drawerOverlay = document.getElementById('drawer-overlay');
  var drawerClose = document.getElementById('drawer-close');

  function openDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    if (drawerOverlay) drawerOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    if (cartToggle) cartToggle.setAttribute('aria-expanded', 'true');
    fetchCartAndRender();
  }

  function closeDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    if (drawerOverlay) drawerOverlay.classList.remove('open');
    document.body.style.overflow = '';
    if (cartToggle) cartToggle.setAttribute('aria-expanded', 'false');
  }

  if (cartToggle) cartToggle.addEventListener('click', openDrawer);
  if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
  if (drawerOverlay) drawerOverlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* =============================================
     CART API – FETCH & RENDER
  ============================================= */
  var FREE_THRESHOLD = 39900; // 399 zł in pennies

  function fetchCartAndRender() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        renderDrawerCart(cart);
        updateCartCount(cart.item_count);
      })
      .catch(function(e) { console.error('Cart fetch error', e); });
  }

  function updateCartCount(count) {
    var badges = document.querySelectorAll('#cart-count, #drawer-count');
    badges.forEach(function(el) { el.textContent = count; });
  }

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' zł';
  }

  function renderDrawerCart(cart) {
    var body = document.getElementById('drawer-body');
    var foot = document.getElementById('drawer-foot');
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-empty"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg><p>Twój koszyk jest pusty</p></div>';
      if (foot) foot.style.display = 'none';
      return;
    }

    var html = '';
    cart.items.forEach(function(item) {
      var imgHtml = item.image
        ? '<img src="' + item.image + '" alt="' + escapeHtml(item.title) + '" style="width:100%;height:100%;object-fit:cover">'
        : '<span style="font-size:2rem">📦</span>';
      html += '<div class="drawer-item">'
        + '<div class="d-item-img">' + imgHtml + '</div>'
        + '<div style="flex:1;min-width:0">'
        + '<div class="d-item-name">' + escapeHtml(item.product_title) + '</div>'
        + (item.variant_title && item.variant_title !== 'Default Title' ? '<div style="font-size:.72rem;color:var(--gray)">' + escapeHtml(item.variant_title) + '</div>' : '')
        + '<div class="d-item-price">' + formatMoney(item.line_price) + '</div>'
        + '<div class="d-qty">'
        + '<button class="d-qty-btn" data-id="' + item.variant_id + '" data-qty="' + (item.quantity - 1) + '" onclick="drawerUpdateQty(this)">−</button>'
        + '<span class="d-qty-n">' + item.quantity + '</span>'
        + '<button class="d-qty-btn" data-id="' + item.variant_id + '" data-qty="' + (item.quantity + 1) + '" onclick="drawerUpdateQty(this)">+</button>'
        + '<button class="d-remove" data-id="' + item.variant_id + '" onclick="drawerRemoveItem(this)">Usuń</button>'
        + '</div>'
        + '</div>'
        + '</div>';
    });
    body.innerHTML = html;

    if (foot) {
      foot.style.display = '';
      var remaining = FREE_THRESHOLD - cart.total_price;
      var shipMsg = document.getElementById('ship-msg');
      var shipFill = document.getElementById('ship-fill');
      var drawerTotal = document.getElementById('drawer-total');
      var drawerTotalNet = document.getElementById('drawer-total-net');

      if (shipMsg) {
        if (remaining > 0) {
          shipMsg.innerHTML = 'Dodaj jeszcze <strong>' + formatMoney(remaining) + '</strong> do darmowej dostawy';
        } else {
          shipMsg.innerHTML = '✅ Masz darmową dostawę!';
        }
      }
      if (shipFill) {
        var pct = Math.min(100, Math.round(cart.total_price * 100 / FREE_THRESHOLD));
        shipFill.style.width = pct + '%';
      }
      if (drawerTotal) drawerTotal.textContent = formatMoney(cart.total_price);
      if (drawerTotalNet) drawerTotalNet.textContent = formatMoney(Math.round(cart.total_price / 1.23));
    }
  }

  window.drawerUpdateQty = function(btn) {
    var id = btn.dataset.id;
    var qty = parseInt(btn.dataset.qty);
    updateCartItem(id, qty);
  };

  window.drawerRemoveItem = function(btn) {
    var id = btn.dataset.id;
    updateCartItem(id, 0);
  };

  function updateCartItem(variantId, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      renderDrawerCart(cart);
      updateCartCount(cart.item_count);
    })
    .catch(function(e) { console.error('Update cart error', e); });
  }

  /* =============================================
     AJAX ADD TO CART
  ============================================= */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.p-btn');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    var variantId = btn.dataset.productId;
    if (!variantId) return;

    var origText = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14" style="animation:spin .6s linear infinite"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></svg> Dodawanie...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function(item) {
      fetchCartAndRender();
      showToast('Dodano do koszyka: ' + item.product_title, '🛒');
      openDrawer();
    })
    .catch(function(e) {
      console.error('Add to cart error', e);
      showToast('Błąd podczas dodawania do koszyka', '❌');
    })
    .finally(function() {
      btn.disabled = false;
      btn.innerHTML = origText;
    });
  });

  /* =============================================
     PRODUCT PAGE – ATC (form submit)
  ============================================= */
  var atcForm = document.querySelector('form[action="/cart/add"]');
  if (atcForm) {
    atcForm.addEventListener('submit', function(e) {
      // Let it submit normally for product page (non-AJAX)
    });
  }

  /* =============================================
     FAQ ACCORDION
  ============================================= */
  document.addEventListener('click', function(e) {
    var faqItem = e.target.closest('.faq-item');
    if (!faqItem) return;
    faqItem.classList.toggle('open');
  });

  /* =============================================
     STICKY HEADER SHADOW
  ============================================= */
  var header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', function() {
      if (window.scrollY > 10) {
        header.style.boxShadow = '0 2px 12px rgba(0,0,0,.1)';
      } else {
        header.style.boxShadow = '0 1px 4px rgba(0,0,0,.05)';
      }
    }, { passive: true });
  }

  /* =============================================
     MOBILE NAV TOGGLE
  ============================================= */
  var mobToggle = document.getElementById('mob-toggle');
  var mobNav = document.getElementById('mob-nav');
  var mobOverlay = document.getElementById('mob-overlay');
  var mobNavClose = document.getElementById('mob-nav-close');

  function openMobNav() {
    if (!mobNav) return;
    mobNav.classList.add('open');
    mobNav.setAttribute('aria-hidden', 'false');
    if (mobOverlay) mobOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    if (mobToggle) mobToggle.setAttribute('aria-expanded', 'true');
  }

  function closeMobNav() {
    if (!mobNav) return;
    mobNav.classList.remove('open');
    mobNav.setAttribute('aria-hidden', 'true');
    if (mobOverlay) mobOverlay.classList.remove('open');
    document.body.style.overflow = '';
    if (mobToggle) mobToggle.setAttribute('aria-expanded', 'false');
  }

  if (mobToggle) mobToggle.addEventListener('click', openMobNav);
  if (mobNavClose) mobNavClose.addEventListener('click', closeMobNav);
  if (mobOverlay) mobOverlay.addEventListener('click', closeMobNav);

  /* =============================================
     CSS SPIN ANIMATION
  ============================================= */
  var style = document.createElement('style');
  style.textContent = '@keyframes spin{to{transform:rotate(360deg)}}';
  document.head.appendChild(style);

  /* =============================================
     HELPER: ESCAPE HTML
  ============================================= */
  function escapeHtml(str) {
    if (!str) return '';
    return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* =============================================
     INITIALIZE ON DOM READY
  ============================================= */
  document.addEventListener('DOMContentLoaded', function() {
    // Fetch cart count on load
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { updateCartCount(cart.item_count); })
      .catch(function() {});
  });

})();
